export default __webpack_public_path__ + "static/media/news.12f3fd68.jpg";